import { onMounted, onUnmounted, ref, type Ref } from 'vue';

/** Intervalle borné à la durée de vie du composant. */
export function useInterval(
	callback: () => unknown,
	intervalMs = 1000,
): Ref<ReturnType<typeof setInterval> | undefined> {
	const handle = ref<ReturnType<typeof setInterval>>();

	onMounted(() => {
		handle.value = setInterval(callback, intervalMs);
	});
	onUnmounted(() => clearInterval(handle.value));

	return handle;
}
